import runAfterPageLoad from "../runAfterPageLoad";

export default function editPasswordInteractions() {
  runAfterPageLoad(() => {
    passwordInteractions();
  });
}

function passwordInteractions() {
  const pw = document.getElementById("user_password");
  const pw_confirmation = document.getElementById("pw_confirmation");
  if (!pw || !pw_confirmation) return;

  const pattern = ".*^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!?@#$%^&*])(?=.{8,}).*";
  pw.setAttribute("pattern", `${pattern}`);
  pw_confirmation.setAttribute("pattern", `${pattern}`);

  const elements = [pw, pw_confirmation];
  pw.setCustomValidity("Please set a Password first");

  elements.forEach((el) =>
    el.addEventListener("change", () => addCustomMessages(pw, pw_confirmation))
  );

  //prevent empty fields submit
  $("#new_user").submit(function (e) {
    if (pw.value == "" || pw_confirmation.value == "") {
      e.preventDefault();
      addCustomMessages(pw, pw_confirmation);
    }
  });
}

function addCustomMessages(pw, pw_confirmation) {
  const messages = {
    no_password: "Please set a Password first",
    validation: "Please set a password that match the requirements above",
    confirmation: "Please enter the same Password as above",
  };

  if (pw.value == "") {
    pw.setCustomValidity(messages.no_password);
  } else {
    pw.setCustomValidity(pw.validity.patternMismatch ? messages.validation : "");
    const message =
      (pw_confirmation.value == "" || pw_confirmation.validity.patternMismatch) &&
      pw.value != ""
        ? messages.confirmation
        : "";
    pw_confirmation.setCustomValidity(message);
  }
}
